import type {
  IndicesCountryViewModel,
  IndicesMarketGroup,
} from '@app-types/indices';

export type IndicesCountryLayoutRow =
  | {
      kind: 'country';
      country: IndicesCountryViewModel;
      grid: 'us-wide' | 'standard';
    }
  | {
      kind: 'singleton-group';
      countries: readonly IndicesCountryViewModel[];
    };

const isUnitedStates = (country: string): boolean => country.trim().toLowerCase() === 'us';

export const buildIndicesLayoutRows = (
  countries: readonly IndicesCountryViewModel[],
  mktGroup: IndicesMarketGroup,
): IndicesCountryLayoutRow[] => {
  const rows: IndicesCountryLayoutRow[] = [];
  let singletonBuffer: IndicesCountryViewModel[] = [];

  const flushSingletons = () => {
    if (singletonBuffer.length === 0) return;
    rows.push({ kind: 'singleton-group', countries: singletonBuffer });
    singletonBuffer = [];
  };

  countries.forEach((country) => {
    const instrumentCount = country.instruments.length;
    if (instrumentCount === 0) return;

    if (instrumentCount === 1) {
      singletonBuffer.push(country);
      if (singletonBuffer.length === 3) flushSingletons();
      return;
    }

    flushSingletons();
    rows.push({
      kind: 'country',
      country,
      grid: mktGroup === 'world' && isUnitedStates(country.country)
        ? 'us-wide'
        : 'standard',
    });
  });

  flushSingletons();
  return rows;
};
